function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "linear-gradient",
  x1: -583.58,
  y1: -215.16,
  x2: 253.32,
  y2: 119.71,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#bfe6e5"
})), React.createElement("linearGradient", {
  id: "linear-gradient-2",
  x1: -576.46,
  y1: -232.95,
  x2: 260.44,
  y2: 101.92,
  xlinkHref: "#linear-gradient"
}), React.createElement("linearGradient", {
  id: "linear-gradient-3",
  x1: -601.49,
  y1: -170.4,
  x2: 235.41,
  y2: 164.47,
  xlinkHref: "#linear-gradient"
}), React.createElement("linearGradient", {
  id: "linear-gradient-4",
  x1: -594.36,
  y1: -188.2,
  x2: 242.53,
  y2: 146.67,
  xlinkHref: "#linear-gradient"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 32.28,
  cy: 31.27,
  r: 21.27,
  fill: "url(#linear-gradient)"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 83.87,
  cy: 31.27,
  r: 21.27,
  fill: "url(#linear-gradient-2)"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 32.23,
  cy: 83.17,
  r: 21.27,
  fill: "url(#linear-gradient-3)"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 83.83,
  cy: 83.17,
  r: 21.27,
  fill: "url(#linear-gradient-4)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#BFE6E5",
  className: "cls-6 callItOut",
  d: "M32.24 52.61a21.27 21.27 0 0 0 21.09-21.14H32.24z"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#BFE6E5",
  className: "cls-6 callItOut",
  d: "M32.24 62.29v21.13h21.09a21.25 21.25 0 0 0-21.09-21.13zM83.46 83.42V62.29a21.26 21.26 0 0 0-21.09 21.13z"
});

var SvgIcon1 = function SvgIcon1(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 115 115",
    ref: svgRef
  }, props), _ref2, React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, React.createElement("g", {
    "data-name": "Layer 1"
  }, _ref3, _ref4, _ref5, _ref6, _ref7, React.createElement("path", {
    className: "callItOut",
    d: "M83.46 52.61V31.47H62.37a21.27 21.27 0 0 0 21.09 21.14z",
    style: {
      mixBlendMode: "multiply"
    },
    fill: "#33c100"
  }), _ref8)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIcon1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Icon_1.12af0ba2.svg";
export { ForwardRef as ReactComponent };